/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- labels mirror automation FILTER/AUTOMATION key maps */
import { h } from 'vue';
import {
  AUTOMATIONS,
  AUTOMATION_ACTION_TYPES,
} from 'dashboard/routes/dashboard/settings/automation/constants';

/** Matches Flows::BranchConditionsEvaluator::ALLOWED_ATTRIBUTE_KEYS */
export const FLOW_BRANCH_CONDITION_KEYS = [
  'content',
  'status',
  'team_id',
  'labels',
  'assignee_id',
  'inbox_id',
  'priority',
];

const CONDITION_KEY_SET = new Set(FLOW_BRANCH_CONDITION_KEYS);

/** Matches Flows::BranchActionRunner::ACTION_NAMES (subset exposed in UI) */
export const FLOW_BRANCH_ACTION_KEYS = [
  'assign_agent',
  'assign_team',
  'add_label',
  'remove_label',
  'send_message',
  'open_conversation',
  'resolve_conversation',
  'pending_conversation',
  'mute_conversation',
  'snooze_conversation',
  'send_email_transcript',
];

const ACTION_KEY_SET = new Set(FLOW_BRANCH_ACTION_KEYS);

const INPUT_TYPE_MAP = {
  multi_select: 'multiSelect',
  search_select: 'searchSelect',
  plain_text: 'plainText',
  comma_separated_plain_text: 'plainText',
  date: 'date',
};

export function defaultFlowBranchCondition() {
  return {
    attribute_key: 'content',
    filter_operator: 'contains',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  };
}

export function defaultFlowBranchAction() {
  return {
    action_name: 'add_label',
    action_params: [],
  };
}

/**
 * @param {object} options
 * @param {Function} options.t — i18n t
 * @param {import('vue').ComputedRef<object>} options.operators — useOperators().operators
 * @param {Function} options.getConditionDropdownValues
 */
export function buildFlowBranchFilterTypes({
  t,
  operators,
  getConditionDropdownValues,
}) {
  const defs = AUTOMATIONS.message_created.conditions.filter(c =>
    CONDITION_KEY_SET.has(c.key)
  );

  return defs.map(attr => {
    if (attr.disabled) {
      return { value: attr.key, label: attr.name, disabled: true };
    }

    const mappedInputType = INPUT_TYPE_MAP[attr.inputType] || 'plainText';
    const optionsList = getConditionDropdownValues(attr.key) || [];

    const filterOperators = (attr.filterOperators || []).map(op => {
      const enriched = operators.value?.[op.value];
      if (enriched) return enriched;
      return {
        value: op.value,
        label: t(`FILTER.OPERATOR_LABELS.${op.value}`),
        hasInput: true,
        inputOverride: null,
        icon: h('span', { class: 'i-ph-equals-bold !text-n-blue-11' }),
      };
    });

    return {
      attributeKey: attr.key,
      value: attr.key,
      attributeName: attr.name,
      label: t(`AUTOMATION.ATTRIBUTES.${attr.name}`),
      inputType: mappedInputType,
      options: optionsList,
      filterOperators,
      dataType: 'text',
      attributeModel: attr.customAttributeType || 'standard',
    };
  });
}

export function buildFlowBranchActionTypes(t, { slaEnabled = true } = {}) {
  let list = AUTOMATION_ACTION_TYPES.filter(a => ACTION_KEY_SET.has(a.key));
  if (!slaEnabled) {
    list = list.filter(({ key }) => key !== 'add_sla');
  }
  return list.map(action => ({
    ...action,
    label: t(`AUTOMATION.ACTIONS.${action.label}`),
  }));
}
